import React from 'react';
import PropTypes, { any } from 'prop-types';
import Filter, { FilterModal, FilterSection } from './Filter';
import DropdownFilter from './FilterComponents/CoreComponents/DropdownFilter';

import styles from '../search.scss';

const NationalityFilter = (props) => {
    const { type = '', filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, searchTypes, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    const countries = searchTypes?.countries ? searchTypes.countries : [];
    const filterName = 'nationality';

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={filterName}
                handleFilterClick={handleFilterClick}
                isActive={(filters?.nationality) || filterModal === filterName}
                onClick={() => handleFilterClick(filterName)}
                searchFor={type}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                {type === 'collegeCorner' && !filters.nationality ? 'All nationalities' : 'Nationality'}{filters && filters.nationality ? `: ${filters.nationality}` : ''}
            </Filter>
            {filterModal === filterName && (
                <FilterModal
                    title={'Nationality'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <DropdownFilter
                            options={countries}
                            selected={filterInputs.nationality}
                            placeholder={'Any Country'}
                            onChange={(nationality) => {
                                handleFilterUpdate({ nationality });
                            }}
                            data-testid={dataTestId && `${dataTestId}.dropdown`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

NationalityFilter.propTypes = {
    type: PropTypes.string,
    filters: PropTypes.objectOf(any).isRequired,
    filterInputs: PropTypes.objectOf(any).isRequired,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    closeModals: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    searchTypes: PropTypes.objectOf(any),
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    'data-testid': PropTypes.string,
};

NationalityFilter.defaultProps = {
    type: '',
    handleFilterClick: () => { },
    closeModals: () => { },
    handleFilterSubmit: () => { },
    searchTypes: {},
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    'data-testid': undefined,
};
export default NationalityFilter;
